import format from 'date-fns/format';

export const formatDate = (date, formatStr) => {
  if (!date) {
    return '';
  }

  if (!formatStr) {
    return '';
  }

  const dateObj = new Date(date);
  return format(dateObj, formatStr);
};

export const isReservationDisabled = ({ reservationStatus, isSelfCancelable }) =>
  !(isSelfCancelable && reservationStatus.toLowerCase() === 'confirmed');

export const getReservationLabel = ({
  firstName,
  lastName,
  reservationStatus,
  reservationStatusDate,
  isSelfCancelable,
}) => {
  const name = `${firstName} ${lastName}`;
  if (!reservationStatusDate) {
    return name;
  }
  if (isSelfCancelable && reservationStatus.toLowerCase() === 'confirmed') {
    return name;
  }
  return `${name} - ${reservationStatus.toLowerCase()} on ${formatDate(
    reservationStatusDate,
    'M/dd/yyyy',
  )}`;
};
